import { generateHTML } from "@tiptap/core";
import { Table } from "@tiptap/extension-table";
import { MarkdownManager } from "@tiptap/markdown";

import {
  buildMarkdownEditorExtensions,
  buildSoftBreakMarked,
} from "src/components/markdown-editor/extensions";

// Editor-only behavior; the static render needs just the schema and the markdown parse hooks.
const EDITOR_ONLY_EXTENSIONS = new Set(["markdown", "markdownPaste"]);

const STATIC_EXTENSIONS = buildMarkdownEditorExtensions()
  .filter((extension) => !EDITOR_ONLY_EXTENSIONS.has(extension.name))
  // The editor's table node view wraps each table in `.tableWrapper`; renderWrapper gives static HTML the same wrapper.
  .map((extension) =>
    extension.name === "table"
      ? Table.configure({ renderWrapper: true })
      : extension,
  );

let manager: MarkdownManager | undefined;

// One shared parser: marked never dedupes tokenizers, so building a manager per call would pile them up on the instance.
function getMarkdownManager(): MarkdownManager {
  manager ??= new MarkdownManager({
    marked: buildSoftBreakMarked(),
    extensions: STATIC_EXTENSIONS,
  });
  return manager;
}

/** Markdown as the editor's schema renders it, for read-only views that don't need a live editor. */
export function markdownToHtml(markdown: string): string {
  return generateHTML(getMarkdownManager().parse(markdown), STATIC_EXTENSIONS);
}
